export const dogs = [
    {
      id: 0,
      name: 'Kepler',
      age: 8,
      breed: 'Lhasapoo',
      photo: '../adopty/img/dog1.jpg'
    },
    {
      id: 1,
      name: 'Charlie',
      age: 3,
      breed: 'Beagle',
      photo: '../adopty/img/dog2.jpg'
    },
    {
      id: 2,
      name: 'Boreal',
      age: 2,
      breed: 'Border Collie',
      photo: '../adopty/img/dog3.jpg'
    },
    {
      id: 3,
      name: 'Blue',
      age: 1,
      breed: 'Poodle',
      photo: '../adopty/img/dog4.jpg'
    },
    {
      id: 4,
      name: 'Latte',
      age: 5,
      breed: 'German Shepard',
      photo: '../adopty/img/dog5.jpg'
    },
    {
      id: 5,
      name: 'Jisu',
      age: 1,
      breed: 'Shih Tzu',
      photo: '../adopty/img/dog6.jpg'
    },
    {
      id: 6,
      name: 'Slash',
      age: 2,
      breed: 'Golden Retriever',
      photo: '../adopty/img/dog7.jpg'
    },
    {
      id: 7,
      name: 'Vader',
      age: 5,
      breed: 'Border Collie',
      photo: '../adopty/img/dog8.jpg'
    },
    {
      id: 8,
      name: 'Doug',
      age: 3,
      breed: 'English Cocker Spaniel',
      photo: '../adopty/img/dog9.jpg'
    }
  ]

export const cats = [
  {
    id: 0,
    name: 'Bruce',
    age: 8,
    breed: 'Shorthair',
    photo: '../adopty/img/cat1.jpg'
  },
  {
    id: 1,
    name: 'Crumbles',
    age: 3,
    breed: 'Maine Coon',
    photo: '../adopty/img/cat2.jpg'
  },
  {
    id: 2,
    name: 'Diana',
    age: 2,
    breed: 'Shorthair',
    photo: '../adopty/img/cat3.jpg'
  },
  {
    id: 3,
    name: 'Aurora',
    age: 3,
    breed: 'Siamese',
    photo: '../adopty/img/cat4.jpg'
  },
  {
    id: 4,
    name: 'Mike',
    age: 7,
    breed: 'Shorthair',
    photo: '../adopty/img/cat5.jpg'
  },
  {
    id: 5,
    name: 'Slinky',
    age: 4,
    breed: 'Shorthair',
    photo: '../adopty/img/cat6.jpg'
  },
  {
    id: 6,
    name: 'Chudd',
    age: 5,
    breed: 'Scottish Fold',
    photo: '../adopty/img/cat7.jpg'
  },
  {
    id: 7,
    name: 'Meepers',
    age: 1,
    breed: 'Shorthair',
    photo: '../adopty/img/cat8.jpg'
  },
  {
    id: 8,
    name: 'Carl',
    age: 3,
    breed: 'Shorthair',
    photo: '../adopty/img/cat9.jpg'
  }
]
